module.exports = __webpack_public_path__ + "img/image-16.bf0b4503.webp";